import React from 'react';
import styles from './Ticker.module.css';

// We now add a 'titleColor' and 'type' to each object.
const tickerData = [
    {
        type: 'quote',
        category: 'SOCIAL',
        name: 'Hinge',
        titleColor: '#2de2a3', // Vibrant Green
        content: '"We chose Sendbird for its feature-rich chat service and proven ability to support our traffic and growth."'
      },
      {
        type: 'stat',
        category: 'ON DEMAND',
        name: 'miso',
        titleColor: '#f7d147', // Vibrant Yellow
        content: '43%',
        subtext: 'Estimated cost savings'
      },
      {
        type: 'quote',
        category: 'MARKETPLACE',
        name: 'REDFIN',
        titleColor: '#e64c3c', // Red
        content: '"The onboarding package was exceptionally beneficial and responsive. The team quickly adapted and addressed our evolving needs, ensuring our requirements were met."'
      },
      {
        type: 'stat',
        category: 'FINTECH',
        name: 'maya',
        titleColor: '#00d1ff', // Bright Cyan
        content: '56%',
        subtext: 'Cost reduction on support'
      },
      {
        type: 'quote',
        category: 'SOCIAL',
        name: 'Porter',
        titleColor: '#ff9a2f', // Orange
        content: '"Sendbird boosted engagement, improved conversions, and reduced SMS costs with seamless notification integration."'
      },
      {
        type: 'stat',
        category: 'B2B SOFTWARE',
        name: 'Clip',
        titleColor: '#c87eff', // Purple
        content: '70%',
        subtext: 'Queries automatically answered'
      },
      {
        type: 'quote',
        category: 'FINTECH',
        name: 'Paytm',
        titleColor: '#3498db', // Blue
        content: '"Sendbird took on the complexities of real-time messaging, saving us significant resources and effort."'
      },
      {
        type: 'quote',
        category: 'RETAIL',
        name: 'Carousell',
        titleColor: '#f7d147', // Vibrant Yellow
        content: '"Sendbird is an important partner for Carousell."'
      },
      {
        type: 'quote',
        category: 'TRAVEL',
        name: 'Hostelworld',
        titleColor: '#ff7eb3', // Pink
        content: '"I’m confident if we did this in house, it would have been at least six to nine months without Sendbird."'
      },
      {
        type: 'stat',
        category: 'TELECOM',
        name: 'Virgin Mobile',
        titleColor: '#e64c3c', // Red
        content: '96%',
        subtext: 'CSAT achievement'
      },
       {
        type: 'quote',
        category: 'FINTECH',
        name: 'Telepass',
        titleColor: '#2de2a3', // Vibrant Green
        content: '"The integration of Sendbird\'s voice API was very fast and well-supported by their team."'
      },
      {
        type: 'quote',
        category: 'SPORTS',
        name: 'Yahoo Sports',
        titleColor: '#c87eff', // Purple
        content: '"We chose Sendbird because of the feature set. The feature set is very rich, very customizable, and easy to use."'
      }
];


const Ticker = () => {
  // A helper function to determine the right CSS class for the content
  const getContentClass = (item) => {
    return item.type === 'stat' ? styles.statContent : styles.cardContent;
  };

  const renderCard = (item, index) => (
    <div className={styles.tickerCard} key={index}>
      <span className={styles.cardCategory}>{item.category}</span>
      {/* The color is now applied using an inline style from our data object */}
      <div className={styles.cardName} style={{ color: item.titleColor }}>
        {item.name}
      </div>
      {/* We use our helper function to apply a special class for stats */}
      <div className={getContentClass(item)}>{item.content}</div>
      {item.subtext && <div className={styles.cardSubtext}>{item.subtext}</div>}
    </div>
  );

  return (
    <div className={styles.tickerContainer}>
      <div className={styles.tickerWrapper}>
        <div className={styles.tickerContent}>
          {tickerData.map(renderCard)}
          {tickerData.map((item, index) => renderCard(item, `duplicate-${index}`))}
        </div>
      </div>
    </div>
  );
};

export default Ticker;